import {FirmTypeFilterItem} from '~/components/advanced_table/components/filter_items/firm_type_filter_item'

const FIRM_TYPES = [
	{id: 'billingInfos', t: 'common.billing_info'},
	{id: 'organisations', t: 'common.organisation'},
	{id: 'environments', t: 'common.environment'},
]

export const useFirmTypeFilter = () => {
	const filterFn = (item, filterValues) => {
		return filterValues.includes(item.tableName)
	}

	return {
		items: FIRM_TYPES,
		filterFn,
		ItemComponent: FirmTypeFilterItem,
	}
}
